/* Blog-article content normalizer — pairs with the "Timber custom: article
   skin" block at the end of section-blog-post.css.

   Post bodies are authored in the Shopify admin and, in practice, pasted out
   of Google Docs: 13 of the 20 posts live on 2026-09-22 arrived wrapped in
   <span dir="ltr"> / class="isSelectedEnd" / ng-star-inserted noise, with
   tables whose <colgroup> pins pixel widths and whose header row is plain
   <td>. This pass gives every post — including ones pasted tomorrow — one
   document structure without anybody having to clean HTML by hand:

     - unwraps presentational <span>s that carry nothing but paste metadata
     - drops empty paragraphs and stray <br>-only cells
     - demotes an in-body <h1> to <h2> (the template already emits the page's
       one <h1>, and a second one muddies the outline for search + answer
       engines)
     - upgrades a paragraph that is entirely one <strong>/<b> run to a real
       <h3> (the "Frequently asked" pseudo-headings) — same trick as policy.js
     - gives tables a header row, a scroll shell, and content-driven widths

   Everything degrades safely: with JS off the post still renders, just
   without the scroll shell and header emphasis. */
(function () {
  var root = document.querySelector('.tarticle__content');
  if (!root) return;

  /* ---- Paste junk ---------------------------------------------------- */

  // A <span> that carries no attribute other than dir/class-noise is doing no
  // work; unwrap it so the prose is plain text nodes again.
  var JUNK_CLASS = /^(isSelectedEnd|ng-star-inserted|\s)+$/;
  Array.prototype.slice.call(root.querySelectorAll('span')).forEach(function (span) {
    for (var i = 0; i < span.attributes.length; i++) {
      var name = span.attributes[i].name;
      if (name === 'dir') continue;
      if (name === 'class' && JUNK_CLASS.test(span.className)) continue;
      return; // a real attribute (style, id, lang…) — leave it alone
    }
    var parent = span.parentNode;
    while (span.firstChild) parent.insertBefore(span.firstChild, span);
    parent.removeChild(span);
  });

  root.querySelectorAll('.isSelectedEnd, .ng-star-inserted').forEach(function (el) {
    el.classList.remove('isSelectedEnd');
    el.classList.remove('ng-star-inserted');
    if (!el.className) el.removeAttribute('class');
  });

  // trim() strips &nbsp; (U+00A0) too — it is ECMAScript WhiteSpace.
  root.querySelectorAll('p, h2, h3, h4, li').forEach(function (el) {
    if (!el.textContent.trim() && !el.querySelector('img, iframe, embed, table, br')) el.remove();
  });

  /* ---- Outline ------------------------------------------------------- */

  root.querySelectorAll('h1').forEach(function (h1) {
    var h2 = document.createElement('h2');
    h2.innerHTML = h1.innerHTML;
    h1.replaceWith(h2);
  });

  root.querySelectorAll('p').forEach(function (p) {
    var only = p.children.length === 1 ? p.children[0] : null;
    if (!only || (only.tagName !== 'STRONG' && only.tagName !== 'B')) return;
    if (only.textContent.trim() !== p.textContent.trim()) return;
    if (!p.textContent.trim()) return;
    var h = document.createElement('h3');
    h.innerHTML = only.innerHTML;
    p.replaceWith(h);
  });

  /* ---- Tables -------------------------------------------------------- */

  root.querySelectorAll('table').forEach(function (table) {
    // base.css styles `table:not([class])` with a full cell grid and a
    // box-shadow ring — a selector that outranks the article skin's. Giving
    // the table a class makes that rule stop matching, which is the cleanest
    // way out of the conflict: the rule is scoped to unclassed tables on
    // purpose.
    table.classList.add('tarticle__table');

    // Pasted pixel widths fight the responsive layout; the CSS neutralizes
    // <col width>, this removes the attribute outright so nothing inherits it.
    table.querySelectorAll('col').forEach(function (col) {
      col.removeAttribute('width');
      col.removeAttribute('style');
    });
    table.removeAttribute('width');

    // Promote the first row to a real header when the author left it as <td>.
    if (!table.querySelector('th')) {
      var first = table.querySelector('tr');
      if (first) {
        first.querySelectorAll('td').forEach(function (td) {
          var th = document.createElement('th');
          th.setAttribute('scope', 'col');
          th.innerHTML = td.innerHTML;
          // Docs leaves the corner cell as a lone <br>; an empty header reads
          // better than a stray line break.
          if (!th.textContent.trim()) th.innerHTML = '';
          td.replaceWith(th);
        });
        var body = first.parentNode;
        if (body && body.tagName === 'TBODY' && !table.querySelector('thead')) {
          var head = document.createElement('thead');
          head.appendChild(first);
          body.parentNode.insertBefore(head, body);
        }
      }
    }

    // Row-label column: mark the first cell of each body row for the skin.
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var cell = tr.firstElementChild;
      if (cell && cell.tagName === 'TD' && cell.textContent.trim()) {
        cell.setAttribute('data-rowlabel', '');
      }
    });

    if (!table.parentNode.classList || !table.parentNode.classList.contains('tarticle__table-scroll')) {
      var shell = document.createElement('div');
      shell.className = 'tarticle__table-scroll';
      shell.setAttribute('role', 'region');
      shell.setAttribute('tabindex', '0');
      shell.setAttribute('aria-label', 'Comparison table');
      table.parentNode.insertBefore(shell, table);
      shell.appendChild(table);
    }
  });

  root.classList.add('tarticle-normalized');
})();
